import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHelmet = ({
  title,
  description,
  keywords = '',
  ogImage = '/og-image.jpg',
  ogImageWidth = '1200',
  ogImageHeight = '630',
  canonicalUrl = '',
  schemaData = null,
  articlePublishedTime = null,
  articleModifiedTime = null,
  noindex = false,
}) => {
  const siteUrl = process.env.REACT_APP_SITE_URL || (typeof window !== 'undefined' ? window.location.origin : 'https://webyoufirst.fr');
  const fullCanonicalUrl = canonicalUrl ? `${siteUrl}${canonicalUrl}` : (typeof window !== 'undefined' ? window.location.href : siteUrl);
  const fullOgImage = ogImage.startsWith('http') ? ogImage : `${siteUrl}${ogImage}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullCanonicalUrl} />

      {/* Robots — E-E-A-T & Snippets Google */}
      {noindex
        ? <meta name="robots" content="noindex, nofollow" />
        : <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      }
      <meta name="author" content="WEB YOU FIRST" />
      <meta name="publisher" content="WEB YOU FIRST" />

      {/* hreflang */}
      <link rel="alternate" hrefLang="fr-FR" href={fullCanonicalUrl} />
      <link rel="alternate" hrefLang="x-default" href={fullCanonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={articlePublishedTime ? 'article' : 'website'} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:image:width" content={ogImageWidth} />
      <meta property="og:image:height" content={ogImageHeight} />
      <meta property="og:image:alt" content={title} />
      <meta property="og:site_name" content="WEB YOU FIRST" />
      <meta property="og:locale" content="fr_FR" />
      {articlePublishedTime && <meta property="article:published_time" content={articlePublishedTime} />}
      {articleModifiedTime && <meta property="article:modified_time" content={articleModifiedTime} />}
      {articlePublishedTime && <meta property="article:author" content="WEB YOU FIRST" />}

      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@webyoufirst" />
      <meta name="twitter:url" content={fullCanonicalUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullOgImage} />
      <meta name="twitter:image:alt" content={title} />

      {/* Schema.org JSON-LD */}
      {schemaData && (
        <script type="application/ld+json">
          {JSON.stringify(Array.isArray(schemaData) ? schemaData : [schemaData])}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHelmet;
